function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// @ts-check
import Vue from 'vue';
import { sync, get } from 'vuex-pathify';
import template from './product-information.html';

var ProductInformation = /*#__PURE__*/function () {
  function ProductInformation() {
    _classCallCheck(this, ProductInformation);
  }

  _createClass(ProductInformation, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-product-information', {
        template: template,
        props: {
          labels: {
            type: Object
          },
          options: {
            type: Object
          },
          rules: {
            type: Object
          },
          countries: {
            type: Array
          },
          currentCountry: {
            type: String
          },
          prepopulateDosageForm: {
            type: Boolean,
            "default": false
          },
          productIndex: {
            type: Number,
            "default": null
          }
        },
        methods: {
          getInputLabels: function getInputLabels(target) {
            return {
              input: {
                label: this.labels[target].label,
                description: this.labels[target].description
              },
              checkbox: {
                label: this.labels.checkBox.label
              }
            };
          }
        },
        computed: {
          form: sync('forms/form'),
          products: sync('forms/form@products'),
          dosageForms: get('forms/dosageForms'),
          promotedCountry: function promotedCountry() {
            return this.currentCountry;
          },
          hasDosageFormDropdown: function hasDosageFormDropdown() {
            return this.form.ctr === 'GB' || this.form.ctr === 'AU';
          }
        }
      });
    }
  }]);

  return ProductInformation;
}();

export default ProductInformation;